import { IPaginationRequest } from "interfaces/pagination";
import axios from "axios";

const CCKMemberLogService = axios.create({
  baseURL: `${process.env.REACT_APP_API}/cck-member-log`,
});

const CCKMemberLogServices = {
  getAll: (
    token: string,
    pagination: IPaginationRequest,
    search: string,
    date: {
      start: string;
      end: string;
    }
  ) =>
    CCKMemberLogService.get(
      `list?perPage=${pagination.per_page}&page=${pagination.page}&search=${search}&startDate=${date.start}&endDate=${date.end}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    ),
};

export default CCKMemberLogServices;
